import { render, staticRenderFns } from "./AlertScreen.vue?vue&type=template&id=1b008ed5&scoped=true"
import script from "./AlertScreen.vue?vue&type=script&lang=js"
export * from "./AlertScreen.vue?vue&type=script&lang=js"
import style0 from "./AlertScreen.scss?vue&type=style&index=0&id=1b008ed5&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b008ed5",
  null
  
)

export default component.exports